export default "__VITE_PUBLIC_ASSET__d6aa2434__"